import { useNavigate } from "react-router-dom";
import { useIsV2 } from "../../common/layout/v2/useIsV2";
import { urls } from "../../urls";

export const useProjectNavigation = () => {
  const navigate = useNavigate();
  const isV2 = useIsV2();
  return (projectId: string) => {
    navigate(isV2 ? urls.v2.projects.view.go(projectId) : urls.projects.view.go(projectId));
  };
};
